module.exports = __webpack_public_path__ + "static/media/27.2a964c69.mp3";